import React, {Component} from "react";
import {range} from "lodash";
import simplyContext from "../../../settings/state/simply";

class PaginationFilter extends Component {
    static contextType = simplyContext;

    render() {
        const dataCount = this.props.state.pageCount;
        const dataPage = this.props.state.pageNumber;
        const dataLimit = this.props.state.pageSize;


        let totalPages = Math.ceil(dataCount / dataLimit);
        let startPage = Math.max(dataPage - 2, 1);
        let endPage = Math.min(startPage + 4, totalPages);

        let pageRanges = range(1, (dataCount / dataLimit) + 1)

        if (endPage - startPage + 1 < 5) {
            startPage = Math.max(endPage - 4, 1);
        }

        let pages = range(startPage, endPage + 1);
        return (
            pages.length > 1 ? (
                <nav aria-label="Page navigation example">
                    <ul className="pagination justify-content-center justify-content-lg-start">
                        {dataPage !== 1 ? (
                                <li onClick={() => dataPage !== 1 ? this.props.func('page',1) : null} className="page-item">
                                <span className='page-link cBg3 text-dark cFontSize12 cCursorPointer' aria-hidden="true">&laquo;</span>
                            </li>
                        ) : null}

                        {pages.map((page, index) => (
                            <li key={index} className="page-item"
                                onClick={() => page !== dataPage ? this.props.func('page',page) : null}>
                                  <span
                                      className={`page-link ${page === dataPage ? "fw-bold cBg2 cHover5 text-white cFontSize12 cCursorDefault" : "cBg3 text-dark cFontSize12 cCursorPointer"}`}>
                                    {page}
                                  </span>
                            </li>
                        ))}

                        {dataPage !== pageRanges[pageRanges.length - 1] ? (
                             <li onClick={() => dataPage !== pageRanges[pageRanges.length - 1] ? this.props.func('page',pageRanges[pageRanges.length - 1]) : null}
                                className="page-item">
                                <span className='page-link cBg3 text-dark cFontSize12 cCursorPointer' aria-hidden="true">&raquo;</span>
                            </li>
                        ) : null}
                    </ul>
                </nav>
            ) : null
        );
    }
}

export default PaginationFilter;